module.exports = __webpack_public_path__ + "img/1sb_five_stars_selected_ekomi_d.b4c03dd.svg";